import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import {
    ConnectedBlockRenderer,
    ConnectedOwnCollectionPageWrapper,
    ConnectedPageHelmet,
    ConnectedProductList,
} from '../../../connectors';
import { MeilisearchStoreKey } from '../../../entities/@search/Meilisearch/Meilisearch';
import { AppRoute } from '../../../entities/Routing/Routing';
import { inStockSort } from '../../../entities/Sort/Sort';

import './OwnCollectionPage.scss';

interface OwnCollectionPageProps {
    className?: string;
}

export const OwnCollectionPage: FC<OwnCollectionPageProps> = ({
    className = '',
}): ReactElement => (
    <ConnectedOwnCollectionPageWrapper>
        {({ baseFilter }) => (
            <Page className={`own-collection-page ${className}`}>
                <ConnectedPageHelmet appRoute={AppRoute.ownCollection} />

                <ConnectedBlockRenderer
                    appRoute={AppRoute.ownCollection}
                    className="own-collection-page__block-renderer"
                />

                {baseFilter && (
                    <ConnectedProductList
                        showFilterBar
                        storeKey={MeilisearchStoreKey.ownCollection}
                        baseFilter={baseFilter}
                        baseSort={inStockSort}
                        className="own-collection-page__product-list"
                    />
                )}
            </Page>
        )}
    </ConnectedOwnCollectionPageWrapper>
);
